import {
  GroopitFilterAssignmentDisplayDTO,
  GroopitFilterAssignmentDTO,
  GroopitFilterDisplayDTO,
  GroopitFilterDTO,
} from "../../groopit-js/client";

export class GroopitFilterDisplay extends GroopitFilterDisplayDTO {
  static convertToGroopitFilter(
    display: GroopitFilterDisplayDTO,
  ): GroopitFilterDTO {
    return new GroopitFilterDTO({
      assignments: display.assignments.map(
        (a: GroopitFilterAssignmentDisplayDTO) =>
          new GroopitFilterAssignmentDTO({
            id: a.id,
            startDate: a.dateRange?.startDate,
            endDate: a.dateRange?.endDate,
            creators: a.creators?.map((c) => c.id),
            componentModelIds: a.componentModelIds,
            components: a.components ? [...a.components] : [],
          }),
      ),
      creators: display.creators.map((c) => c.id),
      tags: display.tags,
      tagsOperation: display.tagsOperation,
      choices: display.choices,
      choicesOperation: display.choicesOperation,
      startDate: display.dateRange?.startDate,
      endDate: display.dateRange?.endDate,
      query: display.query,
      feedFilterDataTypes: display.feedFilterDataTypes,
    });
  }
}
